import type { Card, GameState } from './types';

export const CUSTODIAN_FULL_PROCESSING_THRESHOLD = 6;

function norm(value: unknown): string {
  return String(value ?? '').trim().toLowerCase();
}

export function custodianTitleKey(value: unknown): string {
  return norm(value).replace(/[’'`]/g, '');
}

export function isCustodianEnemy(enemyId: unknown): boolean {
  return custodianTitleKey(enemyId) === 'custodian';
}

export type CustodianTrackedCardType = 'attack' | 'defense' | 'utility' | null;

export function getCustodianTrackedCardType(card: Card | null | undefined): CustodianTrackedCardType {
  if (!card || card.kind === 'enemy') return null;

  const tag = norm((card as any).tag);
  if (tag === 'attack' || tag === 'defense' || tag === 'utility') return tag as CustodianTrackedCardType;

  const subtitle = norm((card as any).subtitle);
  if (subtitle.includes('attack')) return 'attack';
  if (subtitle.includes('defense')) return 'defense';
  if (subtitle.includes('utility')) return 'utility';

  return null;
}

export function getCustodianTrackedTotal(state: GameState): number {
  const attacks = Math.max(0, Number((state as any).custodianExiledAttackCount ?? 0) || 0);
  const defenses = Math.max(0, Number((state as any).custodianExiledDefenseCount ?? 0) || 0);
  const utilities = Math.max(0, Number((state as any).custodianExiledUtilityCount ?? 0) || 0);
  return attacks + defenses + utilities;
}
